import { useContainer } from '@hub-la/fe-container'
import { HttpClient } from '@hub-la/fe-core-http-client'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { QueryKey } from '../../domain/dtos/query-keys'
import { UpdatePayout } from '../../usecases/update-payout'
import { UpdatePayoutValues } from '../pages/update-payout-modal'

export const useUpdatePayout = () => {
  const container = useContainer()
  const queryClient = useQueryClient()

  return useMutation(
    [QueryKey.updatePayout],
    (input: UpdatePayoutValues) => new UpdatePayout(container.get(HttpClient)).execute(input),
    {
      retry: false,
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['getPayout'] })
      },
    },
  )
}
